<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <figure>
        <ng-container *ngIf="isAcmic; else maIcon">
          <img src="./assets/img/images/icon-warning.svg" alt="no match"/>
        </ng-container>
        <ng-template #maIcon>
          <img src="./assets/img/images/expired.svg" alt="no match"/>
        </ng-template>        
      </figure>
    </div>
    <h1 class="title-copy">{{ 'THE_INFORMATION_ENTERED_DOESNT_MATCH' | translate }}</h1>
  </div>
</div>
<app-policy-not-found-screen></app-policy-not-found-screen>
<div *ngIf="showMessageApp" class="grey-color app-font-size">
  {{ 'MA_ONLY_APP_NOTIFICATION' | translate }}
</div>
